import { render, staticRenderFns } from "./ReturnPickup.vue?vue&type=template&id=65ff1a78&scoped=true"
import script from "./ReturnPickup.vue?vue&type=script&lang=js"
export * from "./ReturnPickup.vue?vue&type=script&lang=js"
import style0 from "./ReturnPickup.vue?vue&type=style&index=0&id=65ff1a78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ff1a78",
  null
  
)

export default component.exports